module.exports = __webpack_public_path__ + "static/media/Pattern15.088ea948.png";